import { useMutation } from "@tanstack/react-query";
import { useToast } from "../components/ui/use-toast";
import { fetch } from "./fetch";
import { useNavigate } from "react-router-dom";

const revertBookingToOffer = async (bookingId: string) => {
  return fetch(`/api/bookings/${bookingId}/revert-to-offer`, "DELETE");
};

export const useBookingRevertToOfferMutation = (bookingId: string) => {
  const { toast, dismiss } = useToast();
  const navigate = useNavigate();

  return useMutation({
    mutationFn: (data: { toastId: any }) => revertBookingToOffer(bookingId),
    onSuccess: (_, variables) => {
      dismiss(variables.toastId);

      toast({
        title: "Success",
        description: "Booking reverted to offer successfully!",
        variant: "default",
      });
      navigate(`/bookings`, { replace: true });
    },
    onError: (error: any, variables) => {
      console.log("error", error.context);
      dismiss(variables.toastId);
      toast({
        title: "Error",
        description: error.context.message || "Failed to revert booking to offer!",
        variant: "destructive",
      });
    },
  });
};
